import { AuthenticatedRoute, RequireOrganization } from "../components/ProtectedRoute";
import { AdaptiveLayout } from "../components/AdaptiveLayout";

export default [AuthenticatedRoute, RequireOrganization, AdaptiveLayout];